import { Flex } from 'antd';
import { spacing } from '../../theming';
import { labelStyle } from './vinExtractionStyles';

const StatusStripItem = ({ label, children }) => (
    <Flex align="center" gap={spacing[0.5]} wrap="wrap">
        <span style={labelStyle}>{label}</span>
        {children}
    </Flex>
);

export default StatusStripItem;
